import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Pain } from './components/Pain';
import { Revelation } from './components/Revelation';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { Closing } from './components/Closing';
export function App() {
  return <div className="min-h-screen bg-prime-black text-prime-text selection:bg-prime-gold selection:text-prime-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Hook data-id="element-4" />
        <Pain data-id="element-5" />
        <Revelation data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Offer data-id="element-8" />
        <Pricing data-id="element-9" />
        <FAQ data-id="element-10" />
        <Guarantee data-id="element-11" />
        <Closing data-id="element-12" />
      </main>

      <footer className="bg-black py-8 text-center text-prime-textMuted text-sm border-t border-white/5" data-id="element-13">
        <div className="max-w-4xl mx-auto px-4" data-id="element-14">
          <p className="mb-4" data-id="element-15">
            © {new Date().getFullYear()} The Prime Architect. Todos los
            derechos reservados.
          </p>
          <p className="text-xs opacity-50 max-w-2xl mx-auto" data-id="element-16">
            Descargo de responsabilidad: La información proporcionada en este
            sitio web tiene fines educativos únicamente y no pretende sustituir
            el consejo médico profesional, el diagnóstico o el tratamiento.
            Siempre busque el consejo de su médico u otro proveedor de salud
            calificado con cualquier pregunta que pueda tener sobre una
            condición médica.
          </p>
        </div>
      </footer>
    </div>;
}